const FOUNDER_IMG =
  "https://customer-assets-jt897jd0.emergentagent.net/job_ecom-hub-305/artifacts/udl9nv2k_image.png";

export default function About() {
  return (
    <div data-testid="about-page" className="pt-20 min-h-screen bg-[#F8F5F0]">
      <section className="max-w-[680px] mx-auto px-6 py-24 sm:py-28">
        <p className="text-xs uppercase tracking-[0.3em] text-[#C6A769] mb-6 text-center">
          The Founder
        </p>
        <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#4A3F35] mb-10 text-center">
          About Me
        </h1>
        <div className="w-16 h-px bg-[#C6A769] mx-auto mb-14" />

        <div className="relative mx-auto w-fit mb-14">
          <div className="absolute -top-3 -left-3 w-full h-full border border-[#C6A769]/60" />
          <img
            src={FOUNDER_IMG}
            alt="Benz, founder of Benz the Brand"
            data-testid="founder-image"
            className="relative w-[280px] sm:w-[340px] object-cover shadow-[0_20px_50px_-20px_rgba(74,63,53,0.35)]"
          />
        </div>

        <p
          data-testid="about-intro"
          className="font-serif-display text-2xl sm:text-3xl italic text-[#4A3F35] text-center mb-12 leading-snug"
        >
          Hi, I'm Benz, the founder of BENZ THE BRAND.
        </p>

        <div className="space-y-7 text-[15px] sm:text-base text-[#4A3F35]/70 leading-[1.9]">
          <p>
            I chose the name "Soft Life" because every woman I know, or have ever
            connected with, has said they're in their "soft girl era." But what does
            that actually mean? To most, it can look like laziness, or a lifestyle
            handed to us by someone else's definition. To me, soft life means
            discipline. It means realizing tomorrow isn't promised, so you bet on
            yourself today. It means stepping out of your comfort zone, releasing the
            obsession with aesthetics, and honoring your feelings and emotions along
            the way. A soft life isn't given to you, it's created by you, for you.
          </p>
          <p>
            That's the belief behind the Soft Life Reset Workbook and the 365 Day Soft Life
            Reset Calendar. I built
            these tools because structure and softness aren't opposites: you can pursue
            your goals, financial and personal, without hustling yourself into the
            ground. These are the same prompts and routines that worked for me: honest
            money check-ins, gentle discipline, and space to reconnect with what I
            actually want.
          </p>
          <p>
            I'm not a financial advisor or therapist, just someone who's done the work
            and wants to share it. Everything here comes from lived experience, made
            beautiful enough that you'll actually want to open it.
          </p>
        </div>

        <div className="w-16 h-px bg-[#C6A769] mx-auto my-12" />

        <p className="font-serif-display text-xl sm:text-2xl italic text-[#4A3F35] text-center leading-relaxed">
          This is your reset. Take it one soft, intentional page at a time.
        </p>
      </section>
    </div>
  );
}
